import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { InvoicesListFilterKeys } from '../../model/types';
import { MultipleSelect } from 'shared/ui/MultipleSelect';
import { PaymentMethod } from 'entities/Payment';

interface PaymentMethodSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const PaymentMethodSelect: FC<PaymentMethodSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const paymentMethodOptions = useMemo(() => {
    const commonMethods = Object.values(PaymentMethod).map((group) => ({
      label: t(group, { ns: 'common' }),
      value: group,
    }));

    return [
      ...commonMethods,
      {
        label: t('deposit', { ns: 'common' }),
        value: 'deposit',
      },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(InvoicesListFilterKeys.paymentMethods);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Payment method')}
      placeholder={t('All')}
      bordered
      allowClear
      options={paymentMethodOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
